import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'convo-ui', {
    convoNotFound: 'Convo not found.',
    convos: 'Convos',
    newConvoWith: 'New convo with “{{botName}}”',
    yourConvos: 'Your Convos',
    aiTestChat: 'AI Test Chat',
    aiTestChatPlaceholder: 'Type / for commands or @ for references',
    convoDetails: 'Convo Details',
    messages: 'Messages',
    rewindToHere: 'Rewind to here',
    regenerateResponse: 'Regenerate response',
    closeSelectedConvos: 'Close selected convos',
    analyzeSelectedConvos: 'Analyze selected convos',
    trashSelectedConvos: 'Trash selected convos',
    deleteSelectedConvos: 'Delete selected convos',
    viewConvo: 'View convo',
    analyzeConvo: 'Analyze convo',
    trashConvo: 'Trash convo',
    deleteConvo: 'Delete convo',
    sendMessage: 'Send message',
    generatingResponse: 'Generating response',
    stopGenerating: 'Stop generating',
    connectionAccessReadOnly: 'Tools are now read only.',
    connectionAccessReadWrite: 'Tools can now read and write.',
    compacting: 'Compacting conversation context…',
    contextCompacted: 'Earlier conversation summarized.',
    showSummary: 'Show summary',
    hideSummary: 'Hide summary',
    nothingToSummarize: 'Nothing to summarize right now.',

    // Generic actions / nouns (reused across confirm dialogs)
    delete: 'Delete',
    cancel: 'Cancel',
    actionVerbClose: 'Close',
    actionVerbAnalyze: 'Analyze',
    actionVerbTrash: 'Trash',
    nounConvo: 'Convo',

    // Convo / AgentConvo grid row confirm dialogs
    analyzeConvoConfirmTitle: 'Analyze Convo',
    analyzeConvoConfirmDescription: 'Are you sure you want to initiate analysis of this convo?',
    deleteConvoConfirmTitle: 'Delete Convo',
    deleteConvoConfirmDescription:
      'Are you sure you want to permanently delete the selected convo? This action cannot be undone.',
    deleteConvoDescriptionSuffix: ' This action cannot be undone.',

    analysisInitiatedForConvo: 'Analysis initiated for convo',
    convoMovedToTrash: 'Convo moved to the trash',
    reopenConvo: 'Reopen convo',
    closeConvo: 'Close convo',
    convoReopened: 'Convo reopened',
    convoClosed: 'Convo closed',

    // Convo / AgentConvo grid group actions
    convosClosed: '{{count}} convo closed',
    convosClosed_plural: '{{count}} convos closed',
    convosMovedToTrash: '{{count}} convo moved to trash',
    convosMovedToTrash_plural: '{{count}} convos moved to trash',
    groupAnalysisInitiated: 'Analysis initiated for {{count}} convo',
    groupAnalysisInitiated_plural: 'Analysis initiated for {{count}} convos',
    groupAnalyzeConvoDescriptionMatching:
      'Are you sure you want to initiate analysis of all {{count}} matching convo?',
    groupAnalyzeConvoDescriptionMatching_plural:
      'Are you sure you want to initiate analysis of all {{count}} matching convos?',
    groupAnalyzeConvoDescriptionSelected:
      'Are you sure you want to initiate analysis of the {{count}} selected convo?',
    groupAnalyzeConvoDescriptionSelected_plural:
      'Are you sure you want to initiate analysis of the {{count}} selected convos?',
    groupTrashConvoDescriptionMatching:
      'Are you sure you want to move all {{count}} matching convo to the trash?',
    groupTrashConvoDescriptionMatching_plural:
      'Are you sure you want to move all {{count}} matching convos to the trash?',
    groupTrashConvoDescriptionSelected:
      'Are you sure you want to move the {{count}} selected convo to the trash?',
    groupTrashConvoDescriptionSelected_plural:
      'Are you sure you want to move the {{count}} selected convos to the trash?',

    // ConvoListItem
    editConvo: 'Edit convo',
    duplicateConvo: 'Duplicate convo',
    trashRelatedMemoriesMenu: 'Trash related memories',
    trashedRelatedMemories: 'Trashed {{count}} related memories',
    trashedConvo: 'Trashed convo',
    convoRestoreFailed: 'Could not restore the convo',
    relatedMemoriesLoadFailed: 'Could not load the related memories',
    relatedMemoriesRestoreFailed: 'Could not restore every related memory',
    convoRenamed: 'Convo renamed',
    deleteConvoListConfirmTitle: 'Delete convo?',
    deleteConvoListConfirmDescription:
      'This will delete the convo and all associated messages. This action cannot be undone.',

    // AgentConvosAdminPage
    agentConvosPageTitle: 'Agent Convos',

    // AiChat rewind confirm
    rewindConfirmTitle: 'Start over from here?',
    rewindConfirmDescription:
      'Messages after this point will be discarded and you can change your message to start over.',
    rewindSuccess: 'Convo rewound',

    // AiChatFooter
    switchedTo: 'Switched to “{{name}}”',
    reasoningLevelSet: 'Reasoning level set to “{{value}}”',
    verbositySet: 'Verbosity set to “{{value}}”',

    // AiChatMessageTools
    failedToCopyToClipboard: 'Failed to copy to clipboard',

    // useGenerateName
    failedToGenerateName: 'Failed to generate name',
  });
}
